<template>
  <div>
    <b-list-group-item
      class="d-flex justify-content-between align-items-center tree-item"
      :class="{ selected: isSelected }"
      @click="handleClick"
    >
      <div class="name-item">
        <component
          :is="
            node.children && node.children.length
              ? isOpen
                ? 'b-icon-folder-fill'
                : 'b-icon-folder'
              : 'b-icon-folder'
          "
        />
        <span class="ml-2">{{ node.name }}</span>
      </div>
      <component
        v-if="node.children && node.children.length"
        :is="isOpen ? 'b-icon-chevron-down' : 'b-icon-chevron-right'"
      />
    </b-list-group-item>

    <b-collapse :visible="isOpen" class="ml-4">
      <b-list-group flush>
        <tree-view-item
          v-for="(child, i) in node.children"
          :key="i"
          :node="child"
        />
      </b-list-group>
    </b-collapse>
  </div>
</template>

<script>
import {
  BListGroup,
  BListGroupItem,
  BCollapse,
  BIconFolder,
  BIconFolderFill,
  BIconFile,
  BIconChevronDown,
  BIconChevronRight,
} from "bootstrap-vue";

export default {
  name: "TreeViewItem",
  components: {
    BListGroupItem,
    BCollapse,
    BListGroup,
    BIconFolder,
    BIconFolderFill,
    BIconFile,
    BIconChevronDown,
    BIconChevronRight,
  },
  inject: ["selectNode", "isNodeSelected"],
  props: {
    node: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    isSelected() {
      return this.isNodeSelected(this.node);
    },
  },
  methods: {
    handleClick() {
      this.selectNode(this.node);
      if (this.node.children && this.node.children.length) {
        this.isOpen = !this.isOpen;
      }
    },
  },
};
</script>

<style>
.tree-item {
  cursor: pointer;
  user-select: none;
}
/* Borde azul cuando está seleccionado */
.selected {
  border: 1px solid #007bff;
  border-radius: 0.25rem;
}
</style>
